import ACTIONS from "../constants";

// Navigate to an entity (portfolio, program, project, etc.)
export const navigateToEntity = (
  entityType,
  entityId,
  entityName,
  selectedTab,
  parentContext = null
) => ({
  type: ACTIONS.NAVIGATE_TO_ENTITY,
  payload: {
    entityType,
    entityId,
    entityName,
    selectedTab,
    parentContext,
  },
});

// Navigate back to a specific entity in the breadcrumb path
export const navigateBack = (targetEntity) => ({
  type: ACTIONS.NAVIGATE_BACK,
  payload: {
    targetEntity,
  },
});

// Navigate forward in history
export const navigateForward = () => ({
  type: ACTIONS.NAVIGATE_FORWARD,
});

// Navigate to a specific index in the history
export const navigateToHistoryIndex = (index) => ({
  type: ACTIONS.NAVIGATE_TO_HISTORY_INDEX,
  payload: {
    index,
  },
});

// Sync breadcrumb state with current route
export const syncWithRoute = (entityType, entityId, entityName, selectedTab) => ({
  type: ACTIONS.SYNC_WITH_ROUTE,
  payload: {
    entityType,
    entityId,
    entityName,
    selectedTab,
  },
});

// Update the selected tab for a specific entity
export const updateEntityTab = (entityType, entityId, selectedTab) => ({
  type: ACTIONS.UPDATE_ENTITY_TAB,
  payload: {
    entityType,
    entityId,
    selectedTab,
  },
});

// Set direct navigation (from dashboard directly to an entity)
export const setDirectNavigation = (
  entityType,
  entityId,
  entityName,
  selectedTab
) => ({
  type: ACTIONS.SET_DIRECT_NAVIGATION,
  payload: {
    entityType,
    entityId,
    entityName,
    selectedTab,
  },
});

// Reset breadcrumb to dashboard only
export const resetBreadcrumb = () => ({
  type: ACTIONS.RESET_BREADCRUMB,
});

// Add entity to breadcrumb path
export const addToBreadcrumb = (
  entityType,
  entityId,
  entityName,
  selectedTab
) => ({
  type: ACTIONS.ADD_TO_BREADCRUMB,
  payload: {
    entityType,
    entityId,
    entityName,
    selectedTab,
  },
});

// Remove entity from breadcrumb path
export const removeFromBreadcrumb = (entityType, entityId) => ({
  type: ACTIONS.REMOVE_FROM_BREADCRUMB,
  payload: {
    entityType,
    entityId,
  },
});

// Clear all navigation state
export const clearNavigation = () => ({
  type: ACTIONS.CLEAR_NAVIGATION,
});

// Helper action to handle hierarchical navigation
export const navigateHierarchically = (
  fromEntity,
  toEntity,
  selectedTab
) => {
  return (dispatch, getState) => {
    const state = getState();
    const currentBreadcrumb = state.navigation.get("breadcrumbPath").toJS();

    // Check if we're navigating up or down the hierarchy
    const fromIndex = currentBreadcrumb.findIndex(
      (item) => item.type === fromEntity.type && item.id === fromEntity.id
    );

    if (fromIndex !== -1) {
      // We're navigating from an existing breadcrumb item
      dispatch(
        navigateToEntity(
          toEntity.type,
          toEntity.id,
          toEntity.name,
          selectedTab,
          fromEntity
        )
      );
    } else {
      // Direct navigation
      dispatch(
        setDirectNavigation(
          toEntity.type,
          toEntity.id,
          toEntity.name,
          selectedTab
        )
      );
    }
  };
};

// Helper action to handle tab changes within current entity
export const changeCurrentTab = (selectedTab) => {
  return (dispatch, getState) => {
    const state = getState();
    const currentEntity = state.navigation.get("currentEntity");

    if (currentEntity) {
      dispatch(
        updateEntityTab(currentEntity.type, currentEntity.id, selectedTab)
      );
    }
  };
};

// Helper action to navigate to dashboard
export const navigateToDashboard = () => {
  return (dispatch) => {
    dispatch(resetBreadcrumb());
  };
};

// Helper action to get entity context (selected tab)
export const getEntityContext = (entityType, entityId) => {
  return (dispatch, getState) => {
    const state = getState();
    const entityContexts = state.navigation.get("entityContexts").toJS();
    const entityKey = `${entityType}-${entityId}`;

    return entityContexts[entityKey];
  };
};

// Export all actions as a single object for easier importing
export const navigationActions = {
  navigateToEntity,
  navigateBack,
  navigateForward,
  navigateToHistoryIndex,
  syncWithRoute,
  updateEntityTab,
  setDirectNavigation,
  resetBreadcrumb,
  addToBreadcrumb,
  removeFromBreadcrumb,
  clearNavigation,
  navigateHierarchically,
  changeCurrentTab,
  navigateToDashboard,
  getEntityContext,
};
